<template>
    <v-switch v-model="filterValue" @change="handleInputChange" :label="st(config.label)"></v-switch>
</template>
 
<script> 

import BaseModule from '../../../common/BaseModule.js'

export default {
    name: 'SwitchFilter',
    props: ['config','context'],
    mixins: [BaseModule],
    components: { 
    },
    data() {
        return {
            debounceTimeout: null,
            filterValue: false,
            lastEvent: null
        }
    },
    mounted() {
    },
    destroyed() { 
        clearInterval(this.debounceTimeout);
    },
	watch: {
        context: function() { 
            if (!this.context.filters || this.context.filters.length === 0) {
                this.filterValue = false;
                this.lastEvent = this.filterValue;
                return;
            }
            var filter = this.context.filters.find(f => f.type === 'boolean');
            if (filter) {
                this.filterValue = filter.value === 1 ? true : false;
                this.lastEvent = this.filterValue;
            }
        },
    },
    methods: {
        getValue() {
            return this.filterValue;
        },
        emitFilterValue() {
            if (this.filterValue == this.lastEvent) {
                return;
            }
            this.lastEvent = this.filterValue;
            this.$emit('change',this.filterValue);
        },
        handleInputChange() {
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout); 
            }
            const me = this;
            this.debounceTimeout = setTimeout(() => {
                me.emitFilterValue();
            }, 400);
        }
    }
};
</script>